// Strings locales del módulo M2 · Dominios (docs/08): el i18n global de nav ya tiene
// la clave de la sección; aquí viven las cadenas propias de la pantalla. Sin literales
// sueltos en JSX.
export const domainsI18n = {
  title: "Dominios",
  description: "Tenants de la instancia. Cada dominio tiene un usuario maestro.",
  // Command bar
  create: "Nuevo dominio",
  search: "Buscar por slug o nombre",
  filterStatus: "Estado",
  filterAll: "Todos",
  // Columnas del DataGrid
  columns: {
    slug: "Slug",
    name: "Nombre",
    master: "Maestro",
    registration: "Registro",
    status: "Estado",
  },
  status: {
    active: "Activo",
    suspended: "Suspendido",
  },
  registration: {
    on: "Habilitado",
    off: "Deshabilitado",
  },
  noMaster: "Sin asignar",
  // Estado vacío
  empty: {
    title: "Aún no hay dominios",
    description: "Crea el primer dominio y su usuario maestro para empezar.",
    action: "Crear el primero",
  },
  // Drawer de alta
  createDrawer: {
    title: "Nuevo dominio",
    submit: "Crear dominio",
    sectionDomain: "Dominio",
    sectionMaster: "Usuario maestro inicial",
  },
  // Drawer de edición
  editDrawer: {
    title: "Editar dominio",
    submit: "Guardar cambios",
    sectionGeneral: "General",
    sectionRegistration: "Política de registro",
    sectionQuotas: "Cuotas",
    sectionNode: "Nodo del tenant",
  },
  fields: {
    slug: "Slug",
    slugHint: "Minúsculas, números y guiones (2-32). No se puede cambiar luego.",
    name: "Nombre",
    masterUsername: "Usuario",
    masterUsernameHint: "Minúsculas, números, guion bajo y guion (3-32).",
    masterName: "Nombre para mostrar",
    masterEmail: "Email de contacto (opcional)",
    masterPassword: "Contraseña",
    regEnabled: "Permitir registro self-service",
    regAutoLogin: "Auto-login tras registrarse",
    regRequireEmail: "Exigir email en el registro",
    regRequireVerification: "Exigir verificación de email",
    regDefaultRoles: "Roles por defecto (separados por comas)",
    quotaMaxUsers: "Máximo de usuarios",
    quotaMaxClients: "Máximo de clients M2M",
    quotaUnlimited: "Vacío = sin límite",
    pinToNode: "Forzar todos los usuarios a un único nodo",
    pinToNodeHint:
      "Ancla el tenant a un nodo (elegido automáticamente): todos sus usuarios resolverán siempre al mismo servidor. Desactívalo para repartir por usuario.",
  },
  validation: {
    slugRequired: "Escribe el slug del dominio.",
    slugFormat: "Formato inválido: minúsculas, números y guiones (2-32).",
    nameRequired: "Escribe el nombre del dominio.",
    masterUsernameRequired: "Escribe el usuario del maestro.",
    masterUsernameFormat: "Formato inválido: minúsculas, números, _ y - (3-32).",
    masterPasswordRequired: "Escribe la contraseña del maestro.",
    emailFormat: "El email no tiene un formato válido.",
    quotaNonNegative: "Debe ser un número igual o mayor que cero.",
  },
  // Acciones por fila (menú)
  actions: {
    label: "Acciones del dominio",
    edit: "Editar",
    transfer: "Transferir maestro",
    suspend: "Suspender",
    activate: "Activar",
  },
  // Suspensión / activación (ConfirmDialog)
  suspend: {
    title: "Suspender dominio",
    message:
      "Se bloquearán los inicios de sesión de todos los usuarios de este dominio. ¿Continuar?",
    confirm: "Suspender",
  },
  activate: {
    title: "Activar dominio",
    message: "Se reactivarán los inicios de sesión de este dominio. ¿Continuar?",
    confirm: "Activar",
  },
  // Transferencia de maestro (Drawer)
  transfer: {
    title: "Transferir maestro",
    submit: "Transferir",
    userIdLabel: "ID del nuevo usuario maestro",
    userIdHint: "Debe ser un usuario activo de este dominio (usr_…).",
    userIdRequired: "Escribe el ID del nuevo maestro.",
  },
} as const
